import { render, staticRenderFns } from "./faultlist.vue?vue&type=template&id=4baaa046&scoped=true"
import script from "./faultlist.vue?vue&type=script&lang=js"
export * from "./faultlist.vue?vue&type=script&lang=js"
import style0 from "./faultlist.vue?vue&type=style&index=0&id=4baaa046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baaa046",
  null
  
)

export default component.exports